import {
  LS_USER_CUSTOMER_INVERITE_CREDENTIALS_SET,
  LS_USER_CUSTOM_FLINKS_CREDENTIALS_SET,
  LS_USER_CUSTOM_GLOBAL_PAY_SHARED_SECRET,
  LS_USER_CUSTOM_PLAID_CREDENTIALS_SET,
  useStorage,
} from 'vopay';
import { useClientData } from '@/providers/ClientData.provider';
import { IntegrationConnectedFlag } from '../types';

const { useLocalStorage } = useStorage;

/**
 * The "credentials set" flags arrive on the login response and are persisted to local storage,
 * which is what ClientData is rebuilt from on the next load. Saving credentials from the drawer
 * has to update both — the in-memory ClientData for the card to flip to Connected now, and the
 * stored value so a reload does not flip it back.
 */
export default function useIntegrationConnectionFlags() {
  const { response, setClientData } = useClientData();
  const [, storeFlinks] = useLocalStorage<boolean>(LS_USER_CUSTOM_FLINKS_CREDENTIALS_SET);
  const [, storePlaid] = useLocalStorage<boolean>(LS_USER_CUSTOM_PLAID_CREDENTIALS_SET);
  const [, storeInverite] = useLocalStorage<boolean>(LS_USER_CUSTOMER_INVERITE_CREDENTIALS_SET);
  const [, storeGlobalPay] = useLocalStorage<boolean>(LS_USER_CUSTOM_GLOBAL_PAY_SHARED_SECRET);

  const store: { [flag in IntegrationConnectedFlag]: (value: boolean) => void } = {
    CustomFlinksCredentialsSet: storeFlinks,
    CustomPlaidCredentialsSet: storePlaid,
    CustomInveriteCredentialsSet: storeInverite,
    CustomGlobalPaySharedSecret: storeGlobalPay,
  };

  function markConnected(flag: IntegrationConnectedFlag) {
    store[flag](true);

    setClientData({
      ...response,
      CustomFlinksCredentialsSet: response.CustomFlinksCredentialsSet || flag === 'CustomFlinksCredentialsSet',
      CustomPlaidCredentialsSet: response.CustomPlaidCredentialsSet || flag === 'CustomPlaidCredentialsSet',
      CustomInveriteCredentialsSet: response.CustomInveriteCredentialsSet || flag === 'CustomInveriteCredentialsSet',
      CustomGlobalPaySharedSecret: response.CustomGlobalPaySharedSecret || flag === 'CustomGlobalPaySharedSecret',
    });
  }

  return { markConnected };
}
